import { ELightPath } from './CaptureProfile';

export enum EActionType
{
	Unknown = 0,
	MovePlate = 1,
	ImagePlate = 2,
	OverviewPlate = 3,
	ReserverModules = 4,
	ReleaseModules = 5,
	Scan = 6,
	ChangeTemperature = 7,
	EjectLoadport = 8,
	RetractLoadport = 9,
	Diagnose = 10,
	Other = 99
}

export enum EActionStatus
{
	Created = 0,
	Canceled = 1,
	Faulted = 2,
	RanToCompletion = 3,
	Running = 4,
}

export enum EScheduleEntryType {
  Manual = 0,
  Scheduled = 1,
  ImageNow = 2,
  Unknown = 3,
}

export interface EventLog {
	taskId: string;
	createdDate: string;
	lastUpdatedDate: string;
	description: string;
	actionType: EActionType;
	actionStatus: EActionStatus;
	plateId: string;
	plateNumber: number;
	plateTypeName: string;
	imagingId: string;
	lightPath: ELightPath;
	captureProfileName: string;
	projectName: string;
	experimentName: string;
	scheduled: string;
	scheduleEntryType: EScheduleEntryType
	userName: string;
	isError: boolean;
	errorMessage?: any;
	durationInMinute: number;
	userGroup: string;
}

